"use client";

import BigDecimal from "big.js";
import { FunctionComponent } from "react";
import { NumericFormat } from "react-number-format";

/**
 * A utility component that warps around NumberFormat and provides default options in order to help display currency as text.  Returns a $ on the front as well.
 * @prop value A string or number that will be formatted into currencyt
 */
export const CurrencyDisplay: FunctionComponent<{
  value: number | string | BigDecimal;
  decimalScale?: number;
}> = ({ value, decimalScale = 2 }) => {
  if (value instanceof BigDecimal) value = value.toFixed(2);
  return (
    <NumericFormat
      value={value}
      displayType="text"
      thousandSeparator={true}
      decimalScale={decimalScale}
      fixedDecimalScale={true}
      prefix="$"
    />
  );
};
export default CurrencyDisplay;
